<template>
  <div>
    <BModal
      v-model="roleEditModal"
      hide-footer
      hide-header
      size="lg"
    >
      <RoleEditForm
        :user="selectedUser"
        @refresh="request"
        @cancel="roleEditModal = false"
      />
    </BModal>
    <div class="settings-box">
      <div class="section-title d-flex align-items-center">
        <i class="far fa-user-lock pr-2" />
        {{ $t('settings.access') }}
      </div>
      <div
        v-if="loadingRoles"
        style="width: 370px"
      >
        <Loader />
      </div>
      <RoleList
        v-else
        :roles="roles"
        @show-edit="selectedUser = $event; roleEditModal = true"
      />
      <div style="max-width: 370px;">
        <hr>
        <button
          class="btn btn-sm btn-primary"
          @click="selectedUser = null; roleEditModal = true"
        >
          <i class="fas fa-plus mr-1" />
          {{ $t('settings.roles.add') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RoleEditForm from './RoleEditForm';
import RoleList from './RoleList';

export default {
  data: () => ({
    selectedUser: null,
    roleEditModal: false,
    loadingRoles: false,
    roles: [],
  }),
  components: {
    RoleList,
    RoleEditForm,
  },
  computed: {
    ...mapGetters(['payee']),
  },
  methods: {
    ...mapActions(['getPayeeAccess']),
    ...mapActions('shop', ['getShopCatalogs']),

    request() {
      this.loadingRoles = true;
      this.getPayeeAccess({
        params: {
          tenantId: this.payee.ownerId,
        },
      })
        .then(({ data }) => {
          this.roles = data;
        })
        .finally(() => {
          this.loadingRoles = false;
        });

      this.getShopCatalogs();
    },
  },
  created() {
    this.request();
    this.$emit('page', 'access');
  },
};
</script>
